export default __webpack_public_path__ + "static/media/dashboard-users-icon.feb4994b.svg";